export default "__VITE_ASSET__9db3bf4e__"